import React from 'react';
import { createURL } from '@sm/utils';
import { t } from '@sm/intl';
import NavBarCopy from '../../copy/NavBarCopy';
import Menu from './components/Menu.js';

export const HelpCenterMenu = () => {
  const path = createURL('https://help.surveymonkey.com/', {
    ut_source: 'megamenu',
  });

  const key = 'Help Center';
  const keyLookup = 'HELP_CENTER';
  const menuTitle = t(NavBarCopy[keyLookup]);

  return (
    <Menu title={menuTitle} path={path} menuKey={key}>
      <div />
    </Menu>
  );
};

export default HelpCenterMenu;
